import { createMultiStyleConfigHelpers as r } from "@chakra-ui/react";
const { defineMultiStyleConfig: a } = r(["container", "arrows"]), d = a({
  baseStyle: ({ theme: e, ...t }) => ({
    container: {
      position: "relative",
      shadow: "lg",
      backgroundColor: "white",
      border: "none!important",
      pb: 3,
      px: 4,
      pt: 5,
      borderRadius: "8px !important",
      ".react-datepicker__day-name, .react-datepicker__time-name": {
        display: "inline-block",
        width: "38px",
        textAlign: "center",
        margin: 0.5
      },
      ".react-datepicker__day": {
        display: "inline-block",
        color: "gray.800",
        width: "42px",
        textAlign: "center",
        height: "32px",
        mx: 0,
        my: 0.5,
        _hover: {
          background: "gray.200",
          cursor: "pointer"
        },
        _disabled: {
          opacity: "0.5",
          cursor: "not-allowed",
          pointerEvents: "none"
        },
        ...e.textStyles.body,
        lineHeight: "32px",
        borderRadius: "8px",
        "&--outside-month": {
          color: "gray.600"
        }
      },
      ".react-datepicker__month": {
        px: 0,
        pt: 0,
        mb: 3,
        m: 0
      },
      ".react-datepicker__day--today": {
        background: "inherit",
        color: "teal.500",
        fontWeight: "bold"
      },
      ".react-datepicker__day--selected, .react-datepicker__day--keyboard-selected": {
        background: "teal.50",
        color: "gray.800"
      },
      ".react-datepicker__day--in-range": {
        borderRadius: 0,
        background: "teal.50"
      },
      ".react-datepicker__day--in-selecting-range:not(.react-datepicker__day--selecting-range-end, .react-datepicker__day--range-start)": {
        background: "teal.50",
        borderRadius: 0
      },
      ".react-datepicker__day--range-start, .react-datepicker__day--selecting-range-start:not(.react-datepicker__day--range-end)": {
        background: "teal.200",
        borderRightRadius: 0,
        borderLeftRadius: "8px",
        color: "gray.800"
      },
      ".react-datepicker__day--range-end, .react-datepicker__day--selecting-range-end:not(.react-datepicker__day--range-start)": {
        background: "teal.200",
        borderLeftRadius: 0,
        borderRightRadius: "8px",
        color: "gray.800"
      },
      ".react-datepicker__day-name": {
        width: "36px",
        textTransform: "uppercase",
        ...e.textStyles.bodySmall,
        color: "gray.600"
      },
      ".react-datepicker__header": {
        borderBottom: "none!important",
        backgroundColor: "transparent"
      },
      ".react-datepicker__today-button": {
        ...e.components.Button.variants.ghost({ theme: e, ...t }),
        borderTop: "none !important",
        mt: 1,
        py: 0,
        textAlign: "center",
        ...e.textStyles.bodyBoldSmall,
        "&:hover": {
          cursor: "pointer"
        }
      }
    }
  })
});
export {
  d as default
};
